export default __webpack_public_path__ + "static/media/heroBg.c68abb9d.png";